import { BiLoaderCircle } from "react-icons/bi";

export default function ComingSoon() {
  return (
    <div className="coming-soon-container">
      <h1 className="coming-title">
        Coming Soon</h1>
      <p className="coming-subtitle">We're working hard to bring you something amazing.</p>

      <div className="coming-loader">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <p className="coming-footer">Stay tuned!</p>
    </div>
  );
}
